import { jsxs, jsx } from 'react/jsx-runtime';
import styles from './index.module.scss.js';

const CounterWatermark = ({ images, hidden, assetsBase }) => {
    if (images?.length > 1 && !hidden) {
        return (jsxs("figure", { className: styles.count, children: [jsx("img", { src: `${assetsBase}/static/icons/cactus/camera.svg`, alt: `Questo annuncio ha ${images?.length} immagini`, width: 16, height: 16 }), jsx("span", { "aria-hidden": "true", children: images.length })] }));
    }
    return null;
};

export { CounterWatermark };
//# sourceMappingURL=CounterWatermark.js.map
